import React from "react";
import { Select } from 'antd';
import FormleftNev from "../../../components/common/FormleftNev";
import $, { data } from "jquery";
import queryString from "query-string";
import FormnavBar from "../../../components/common/wizard_navbar";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import services from "../../../services";
import moment from "moment";
import MarcasModal from "./MarcasModal";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";
var parsed = queryString.parse(window.location.search);
var estadoAnulado = false;
const { Option } = Select
const dateFormat = "DD-MM-YYYY";
var idparse;
const InputFieldAll = {
    Identificação: [],
    Propriedade: [],
    Caracterização: [],
    Cedência_de_Marca: [],
    Informação_Complementar: [],
    Processamento: [],
};

const columnKeyMap = {
    nomeEntidadeCedencia: "Entidade Cedida",
    validade: "Validade da Cedência",
};

const columnKeyMapHistory = {
    data_acao: "Data Ação",
    estado: "Estado",
    utilizaddor: "Utilizaddor",
};

const DATA = [
    {
        entidade_cedida: "xxx",
        validade_de_cedência: "xxx",
    },
    {
        entidade_cedida: "xxx",
        validade_de_cedência: "xxx",
    },
];

var OutroThis;
class MarcasNProcesso extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            headName: "MarcaPend",
            parsed: {},
            parsed2:{},
            telkikTable: "",
            idMarcaLocalizacao: 0,
            data: [],
            elementoMarca: [],
            tipo_de_marca: "",
            estado: "pending",
            historyTable: "",
            showPopup: false,
            observation: "",
            requiredField: {
                observation: false,
            },
            marcaLocalizacao: [],
            
            
            
        };
    }
    componentDidMount() {

        $(window).scrollTop(0);
        OutroThis =this
        var filter = {};
        (async () => {
            const marcaLocalizacao = await services.apiCall.requestApi("Marcas/GetProdutosCertificados", filter, 'get')
            this.setState({ marcaLocalizacao });
        })();

        let parsed = queryString.parse(window.location.search);
        var estado = parsed.estado;
       
        console.log("parsed value", parsed);
        idparse = parsed.id
       
        this.setState(
            {
                parsed,
            },
            () => {
                if (parsed.id) {
                    this.getEvaluation(parsed.id);
                }
            }
        );
    }

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            $(window).scrollTop(0);
            let parsed = queryString.parse(window.location.search);
            console.log("parsed value", parsed);
            this.setState(
                {
                    parsed,
                },
                () => {
                    if (parsed.id) {
                       this.getEvaluation(parsed.id);
                    }
                }
            );
        }
    }

    getEvaluation =  async (processID) => {
        const response = await services.apiCall.requestApi(
            `Marcas/ViewMarcasDetalheBackoffice`,
            {
                IDMarca: processID,
            },
            "get"
        );
        if (Object.keys(response).length > 0) {
            console.log("800 response ", response);
            var indexaMais = 0
            this.setState({ idMarcaLocalizacao: response.produtos });
            var htmlAnexoMarca = []
            if(response.estado != "Pendente"){
                estadoAnulado = true
            }else{
                estadoAnulado = false
            }
           
            for (let index = 0; index < response.anexos.length; index++) {

                $($('#id-span-label-id small')[0]).html('Tipo de marca: ' + response.tipoMarca);
                $($('#id-span-label-id small')[1]).html(response.estado);

                var imagem = response.anexos[index].anexo;
                var nome = response.anexos[index].nome;
                var url = response.anexos[index].nome.indexOf('.png') > -1 ? "data:image/png;base64,"+ imagem : "data:application/pdf;base64,"+ imagem;
                
                
                //src="(data:image/png;base64,"+ imagem +")"
                //return <button  onClick={(e) => this.handleChange('data:image/png;base64,'+ imagem)} ></button>
                //$("#anexosBox").append('<button  'onClick={(e) => this.handleChange(data:image/png;base64,"+ imagem +")}' >'+nome+'</button>') 
                $("#anexosBox").append('<button style="text-align: left;background-color: transparent;border: none;font-weight: 600;" id="'+url+'" class="anexoimage ' +nome.replaceAll(' ', '')+'">'+nome+'</button>')
                indexaMais =+ 1

                $(".anexoimage").off("click").on("click" , function(e){

                    var pontos = e.currentTarget.classList[1].split(".");

                    if(e.currentTarget.classList[1].split(".")[pontos.length - 1] == "pdf" || e.currentTarget.classList[1].split(".")[pontos.length - 1] == "PDF"){
                        var data = e.currentTarget.id.split("data:application/pdf;base64,")[1]
                        var byteCharacters = atob(data);
                        var byteNumbers = new Array(byteCharacters.length);
                        for (var i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                        var fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
        
                    }else{
                        var urlBase =  e.currentTarget.id
                        var image = new Image();
                        
                        image.src = urlBase;
                        
                        var w = window.open("");
                        w.document.write(image.outerHTML);
                    }

                    
                })
            }
           
           
            this.setState(
                (preState) => ({
                    ...preState,
                    data: response,
                    estado: response.estado,
                    
                }),
                () => {
                    this.getTableDate(
                        "Processamento",
                        this.state.data.entidadeCedencia
                    );
                    this.createTable(
                        "Processamento",
                        this.state.data.entidadeCedencia
                    );
                    this.createTable("Histórico");
                }
            );
        }

    };
    
    OpenImageAnexos = (e) => {
        console.log(e)
        var win = window.open();
       // win.document.write("<iframe src='" + type + "'><\/iframe>");
    }

    getTableDate = (type, data) => {
        if (type === "Processamento") {
            Object.keys(columnKeyMap).map((key) => {
                data.map((el) => {
                    if (key === "nomeEntidadeCedencia") {
                        el[columnKeyMap[key]] = el.nomeEntidadeCedencia;
                    } else if (key === "validade") {
                        if (el.validade != null){
                            el[columnKeyMap[key]] = moment(
                                el.validade
                            ).format(dateFormat);
                        }
                    }
                });
            });
        }
    };

    handleSubmit = async () => {
        if(($("#Pedente").is(':checked') == true) || ($("#Aprovado").is(':checked') == true && (this.state.idMarcaLocalizacao == null || this.state.idMarcaLocalizacao == '')) || ($("#Reprovado").is(':checked') == true && $("#observation").val() == '')) {
            Swal.fire({
                icon: 'error',
                title: 'Campos obrigatórios por preencher',
                text: 'Preencha os campos em falta e volte a Submeter',
            })
        }else{
            ///let MarcaLocal = +this.state.parsed2.idMarcaLocalizacao;
            let MarcaLocal = +this.state.idMarcaLocalizacao;
            // if (MarcaLocal === 0){
            //     MarcaLocal = null;
            // }
    
            const requestBody = {
                IDEntidade: this.state.parsed.IDEntidade,
                IDMarca: this.state.parsed.id,
                Estado: this.state.estado,
                ObservacoesReprovado: this.state.observation,
                LoggedUser: window.localStorage.getItem('username'),
                IDMarcaLocalizacao: MarcaLocal,
                Produtos : this.state.idMarcaLocalizacao

            };
    
            console.log(requestBody);
            const response = await services.apiCall.requestApi(
                "Marcas/UpdateMarca",
                requestBody,
                "post"
            );
            if (response) {
                window.location.href = document.referrer; // Volta para a URL anterior e recarrega
            }
        }

        
    };
    handleConcluir = async () => {
        
        this.handleSubmit()
    };
    // getRequestBody = () => {
    //     // Have to add observation key in the request body
    //     let observacao;
    //     if (this.state.estado === "Reprovado") {
    //         observacao = this.state.observation;
    //     } else {
    //         observacao = null;
    //     }
    //     return {
    //         IDMarca: this.state.parsed.id,
    //         Estado: this.state.estado,
    //         ObservacoesReprovado: 0,
    //         observacao,
    //     };
    // };

    handleChange = (type, e) => {
        const { requiredField } = this.state;
        const { name, value } = e.target;
        console.log("requiredField => ", requiredField)
        console.log("name => ", name)
        console.log("value => ", value)
        if (Object.keys(requiredField).includes(name) && !value) {
            this.setState({ requiredField: { [name]: true } });
        } else {
            this.setState({ requiredField: { [name]: false } });
        }
        this.setState({
            [name]: value,
        });
    };

    handleChangeMarcaLocalizacao = (e) => {
        this.setState({ idMarcaLocalizacao: e });
        this.setState((prevState) => ({
            data: {
                ...prevState.data, 
                produtos: e 
            }
        }));
    }
    
    handleChangeMarcaAnexo = (e) => {
        console.log(e)
    }
    createTable = (module, data) => {
        if (module === "Processamento") {
            const columnlist = Object.keys(columnKeyMap).map(function (key) {
                return { field: columnKeyMap[key], columnMenuType: "checkbox" };
            });

            console.log("columnlist", columnlist);
            console.log("data", data);


            let telkikTable = (
                <TlkTable
                    notGroup={true}
                    noDownloadButton={true}
                    pageable={false}
                    date={new Date()}
                    notAction={true}
                    viewFor="marcas"
                    forRutoloDetail={true}
                    noFilterShow={true}
                    modulename="marcas"
                    deleteFunc={(id) => this.handleDelete(id)}
                    list={data}
                    columnlist={columnlist}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );

            this.setState({ telkikTable });
        } else if (module === "Histórico") {
            const columnlist = Object.keys(columnKeyMapHistory).map((key) => {
                return {
                    field: columnKeyMapHistory[key],
                    columnMenuType: "checkbox",
                };
            });
            let historyTable = (
                <TlkTable
                    notGroup={true}
                    noDownloadButton={true}
                    pageable={false}
                    date={new Date()}
                    notAction={true}
                    viewFor="marcas"
                    noFilterShow={true}
                    modulename="marcas"
                    deleteFunc={(id) => this.handleDelete(id)}
                    list={data}
                    columnlist={columnlist}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );
            this.setState({
                historyTable,
            });
        }
    };
    handleConfirm = (type, data) => {
        console.log("data in the confirm 800", type, data);
        //let parsed;

        switch (type) {
            case "cancel":
            case "suspend":
                this.setState({
                    desc: data,
                });
                break;
            case "confirmCancel":
                let MarcaLocal2 = +this.state.parsed2.idMarcaLocalizacao;

                // if (MarcaLocal2 === 0){
                //     MarcaLocal2 = null;
                // }

                const requestBody2 = {
                    IDEntidade: this.state.parsed.IDEntidade,
                    IDMarca: this.state.parsed.id,
                    Estado: "Reprovado",
                    ObservacoesReprovado: this.state.observation,
                    LoggedUser: window.localStorage.getItem('username'),
                    IDMarcaLocalizacao: MarcaLocal2,
                    Produtos : this.state.idMarcaLocalizacao
                };

                console.log(requestBody2);
                let response2;
                (async () => {
                    response2 = await services.apiCall.requestApi(
                        "Marcas/UpdateMarca",
                        requestBody2,
                        "post"
                    );
                })();
                if (response2) {
                    this.props.history.goBack();
                }
                break;
            case "confirmSuspend":
                let MarcaLocal = +this.state.parsed2.idMarcaLocalizacao;

                // if (MarcaLocal === 0){
                //     MarcaLocal = null;
                // }

                const requestBody = {
                    IDEntidade: this.state.parsed.IDEntidade,
                    IDMarca: this.state.parsed.id,
                    Estado: "Suspenso",
                    ObservacoesReprovado: this.state.observation,
                    LoggedUser: window.localStorage.getItem('username'),
                    IDMarcaLocalizacao: MarcaLocal,
                    Produtos : this.state.idMarcaLocalizacao
                };

                console.log(requestBody);
                let response;
                (async () => {
                    response = await services.apiCall.requestApi(
                        "Marcas/UpdateMarca",
                        requestBody,
                        "post"
                    );
                })();
                if (response) {
                    this.props.history.goBack();
                }
                break;
            default:
                break;
        }
    };

    handleSuspend = async () => {
        const requestBody = {
            processId: this.state.parsed.id,
            status: "pending",
            userId: 0,
        };
        const response = await services.apiCall.requestApi(
            "Marcas/ProcessStatusUpdate",
            requestBody,
            "post"
        );
        if (response) {
            this.props.history.goBack();
        }
    };

    render() {
        const leftNavFields =
            this.state.parsed.from === "marcasApproved"
                ? { ...InputFieldAll, Histórico: [] }
                : { ...InputFieldAll };
                // let verAnexo2 = this.state.data.anexos.replace("/")[0] 
                // +'/'+ this.state.data.anexos.replace("/")[1] 
                // +'/'+ this.state.data.anexos.replace("/")[2] 
                // +'/'+ this.state.data.anexos.replace("/")[3] 
                // +'/'+ this.state.parsed.id 
                // +'/'+ this.state.data.anexos.replace("/")[4] 
                //       console.log("TTTT23",verAnexo2)
        console.log(this.state.data.entidadeCedencia );
        console.log(this.state.estado, "ESSTADOO")
        return (
            <>
                <div className="dashboard">
                    <FormnavBar
                        parentName="marcas"
                        date={new Date()}
                        to={this.state.parsed.pagina === "/agenda_digital" ? "/agenda_digital" : "/marcasPendentes"}
                        
                        handleSubmit={(data, url) =>
                            this.handleSubmit(data, url)
                        }
                        handleConcluir={(data, url) =>
                            this.handleConcluir(data, url)
                        }
                        parsed={this.state.parsed}
                        type="parcelas"
                        headName={this.state.headName}
                        estado={this.state.parsed.estado}
                        evaluator={true}
                        showDelete={false}
                        showMarcasButton={
                            this.state.parsed.from === "marcasApproved"
                        }
                    />
                    <div className="full-container edit-ward">
                        <FormleftNev
                            InputFieldsAll={leftNavFields}
                            navfor="marcas"
                        />
                        <div className="right-section right-section-processo">
                            <div className="row top-search">
                                {estadoAnulado == false ? (
                                        <div className="col-md-12 rotuloMessageMainDiv">
                                            <div className="rotuloMessageChildDiv">
                                                <span
                                                    style={{
                                                        marginTop: "3px",
                                                        marginRight: "10px",
                                                    }}
                                                    className="k-icon k-i-information"
                                                />
                                                <label>
                                                    Este processo encontra-se em
                                                    validação
                                                </label>
                                            </div>
                                        </div>
                                    ) : ""}
                                <div
                                    className="bg-white middle p20 mb-4"
                                    id="Identificação"
                                >
                                    <div className="head">
                                        <h2>Identificação</h2>
                                        <p className="font-14"></p>
                                    </div>

                                    <div className="row d-flex flex-row  ml-4">
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Número de registo de marca
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.numeroMarca
                                                    ? this.state.data
                                                          .numeroMarca
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Classificação de Nice
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.idClassificacaoNice
                                                    ? this.state.data.idClassificacaoNice
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Designação de marca
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.marca
                                                    ? this.state.data.marca
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Entidade Responsável pelo
                                                Registo
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.entidadeResponsavel
                                                    ? this.state.data
                                                          .entidadeResponsavel
                                                    : "nd"}
                                            </label>
                                        </div>
                                      
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Descrição
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data.descricao}
                                            </label>
                                        </div>
                                        
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Data de Validade
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {moment(
                                                          this.state.data.validade
                                                      ).format(dateFormat)}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="bg-white middle p20 mb-4"
                                    id="Propriedade"
                                >
                                    <div className="head mb-4">
                                        <h2>Agente Económico</h2>
                                        <p className="font-14"></p>
                                    </div>
                                    <div className="row ml-4">
                                        <div className="col-md-6 ">
                                            <label className="rotulos_head mb-0">
                                                Entidade
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.nome
                                                    ? this.state.data
                                                          .nome
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-6 ">
                                            <label className="rotulos_head mb-0">
                                                NIF
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.nif
                                                    ? this.state.data.nif
                                                    : "nd"}
                                            </label>
                                        </div>
                                        {/* <div className="col-md-6">
                                            <label className="rotulos_head mb-0">
                                                País do proprietário
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.descon
                                                    ? this.state.data.descon
                                                    : "nd"}
                                            </label>
                                        </div> */}
                                    </div>
                                </div>
                                <div
                                    className="bg-white middle p20 mb-4"
                                    id="Caracterização"
                                >
                                    <div className="head mb-4">
                                        <h2>Caracterização</h2>
                                        <p className="font-14"></p>
                                    </div>
                                    <div className="row ml-4">
                                        <div className="col-md-3 ">
                                            <label className="rotulos_head mb-0">
                                                Propriedade da Marca
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.propriedadeMarca
                                                    ? this.state.data.propriedadeMarca
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-3 ">
                                            <label className="rotulos_head mb-0">
                                                Tipo de Marca
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.tipoMarca
                                                    ? this.state.data.tipoMarca
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-3 ">
                                            <label className="rotulos_head mb-0">
                                                País
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.pais
                                                    ? this.state.data.pais
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="rotulos_head mb-0">
                                                Propriedade da Marca
                                            </label>
                                            <br />
                                            <div className="d-flex flex-row">
                                                {this.state.data &&
                                                this.state.data.propriaTerceiros &&
                                                this.state.data.propriaTerceiros ===
                                                    "T" ? (
                                                    <>
                                                        <div className="mr-2 ml-2">
                                                            <label htmlFor="TD" title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TD')[0].tooltip : ""}>
                                                                TD
                                                            </label>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name="tipo_de_marca"
                                                                id="TD"
                                                                value="TD"
                                                                title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TD')[0].tooltip : ""}
                                                                checked={
                                                                    this.state
                                                                        .data &&
                                                                    this.state
                                                                        .data
                                                                        .codPropriedadeMarca ===
                                                                        "TD"
                                                                }
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="ml-2 mr-2">
                                                            <label htmlFor="TH" title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TH')[0].tooltip : ""}>
                                                                TH
                                                            </label>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name="tipo_de_marca"
                                                                id="TH"
                                                                value="TH"
                                                                title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TH')[0].tooltip : ""}
                                                                checked={
                                                                    this.state
                                                                        .data &&
                                                                    this.state
                                                                        .data
                                                                        .codPropriedadeMarca ===
                                                                        "TH"
                                                                }
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="mr-2 ml-2">
                                                            <label htmlFor="TE" title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TE')[0].tooltip : ""}>
                                                                TE
                                                            </label>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name="tipo_de_marca"
                                                                id="TE"
                                                                value="TE"
                                                                title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TE')[0].tooltip : ""}
                                                                checked={
                                                                    this.state
                                                                        .data &&
                                                                    this.state
                                                                        .data
                                                                        .codPropriedadeMarca ===
                                                                        "TE"
                                                                }
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="ml-2 mr-2">
                                                            <label htmlFor="TC" title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TC')[0].tooltip : ""}>
                                                                TC
                                                            </label>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name="tipo_de_marca"
                                                                id="TC"
                                                                value="TC"
                                                                title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TC')[0].tooltip : ""}
                                                                checked={
                                                                    this.state
                                                                        .data &&
                                                                    this.state
                                                                        .data
                                                                        .codPropriedadeMarca ===
                                                                        "TC"
                                                                }
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="mr-2 ml-2">
                                                            <label htmlFor="TO" title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TO')[0].tooltip : ""}>
                                                                TO
                                                            </label>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name="tipo_de_marca"
                                                                id="TO"
                                                                value="TO"
                                                                title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'TO')[0].tooltip : ""}
                                                                checked={
                                                                    this.state
                                                                        .data &&
                                                                    this.state
                                                                        .data
                                                                        .codPropriedadeMarca ===
                                                                        "TO"
                                                                }
                                                                readOnly
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="mr-2 ml-2">
                                                            <label htmlFor="PP" title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'PP')[0].tooltip : ""}>
                                                                PP
                                                            </label>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name="tipo_de_marca"
                                                                id="PP"
                                                                value="PP"
                                                                title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'PP')[0].tooltip : ""}
                                                                checked={
                                                                    this.state
                                                                        .data &&
                                                                    this.state
                                                                        .data
                                                                        .codPropriedadeMarca ===
                                                                        "PP"
                                                                }
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="ml-2 mr-2">
                                                            <label htmlFor="PO" title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'PO')[0].tooltip : ""}>
                                                                PO
                                                            </label>
                                                            <input
                                                                className="ml-1"
                                                                type="radio"
                                                                name="tipo_de_marca"
                                                                id="PO"
                                                                value="PO"
                                                                title={this.state.data.propriedadeMarcaTooltip ? this.state.data.propriedadeMarcaTooltip.filter(item => item.codPropriedadeMarca === 'PO')[0].tooltip : ""}
                                                                checked={
                                                                    this.state
                                                                        .data &&
                                                                    this.state
                                                                        .data
                                                                        .codPropriedadeMarca ===
                                                                        "PO"
                                                                }
                                                                readOnly
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {/* conditon to be applied */}
                                        {/* {this.state.data &&
                                        this.state.data.tipoMarcaRequest ===
                                            "PO" ? (
                                            <div className="col-md-6">
                                                <label className="rotulos_head mb-0">
                                                    Tipo de Marca de terceiros
                                                </label>
                                                <br />
                                                <label className="rotulos_content">
                                                    lorem ipsum lorem ipsum
                                                </label>
                                            </div>
                                        ) : null} */}
                                    </div>
                                </div>
                                {this.state.data.entidadeCedencia && (this.state.data.entidadeCedencia[0].nomeEntidadeCedencia !== "" || this.state.data.entidadeCedencia[0].validade !== "") ? ( <div
                                    className="bg-white middle p20 mb-4"
                                    id="Cedência_de_Marca"
                                >
                                     <div className="head mb-4">
                                        <h2>Cedência de Marca</h2>
                                        <p className="font-14"></p>
                                    </div>
                                    {/*<div className="d-flex justify-content-center">
                                        <div className="row w-75 ">
                                            <div>{this.state.telkikTable}</div>
                                        </div>
                                    </div> */}
                                    <div className="row d-flex flex-row  ml-4">
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                            Entidade Cedente
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data.entidadeCedencia ? this.state.data.entidadeCedencia[0].nomeEntidadeCedencia : ""}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Validade
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data.entidadeCedencia ? moment(
                                                          this.state.data.entidadeCedencia[0].validade
                                                      ).format(dateFormat) : ""}
                                            </label>
                                        </div>
                                    </div>
                                    {/* table to be added */}
                                </div>

                                ) : <div></div>}
                                <div
                                    className="bg-white middle p20 mb-4"
                                    id="Informação_Complementar"
                                >
                                    <div className="head mb-4">
                                        <h2>Informação Complementar</h2>
                                        <p className="font-14"></p>
                                    </div>
                                    <div className="row ml-4">
                                    <div className="col-md-6">
                                            <label className="rotulos_head mb-0">
                                            Link/URL registo de marca
                                            </label>
                                            <br />
                                            <a target="_blank" className="rotulos_content" style={{wordBreak: "break-all"}} href={this.state.data.entidadeRegistoUrl}>
                                                {this.state.data &&
                                                this.state.data.entidadeRegistoUrl
                                                    ? this.state.data.entidadeRegistoUrl
                                                    : "nd"}
                                            </a>
                                        </div>
                                        <div className="col-md-6" >
                                            <label className="rotulos_head mb-0" id="anexos">
                                            Anexos
                                            </label>
                                            <br />
                                           <div id="anexosBox"></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="bg-white middle p20 mb-4"
                                    id="Processamento"
                                >
                                    <div className="head mb-4">
                                        <h2>Processamento</h2>
                                        <p className="font-14"></p>
                                    </div>
                                    <div className="row ml-4">
                                        <div className="col-md-4 ">
                                            <label className="rotulos_head mb-0">
                                                Data de submissão de pedido de validação da marca
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.dataCriado
                                                    ? moment(
                                                          this.state.data
                                                              .dataCriado
                                                      ).format(dateFormat)
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                                Submetido por
                                            </label>
                                            <br />
                                            <label className="rotulos_content">
                                                {this.state.data &&
                                                this.state.data.criadoPor
                                                    ? this.state.data.criadoPor
                                                    : "nd"}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="rotulos_head mb-0">
                                            Produtos*
                                            </label>
                                            <br />
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                // maxTagTextLength={ 3 }
                                                placeholder="Selecione os produtos associados à marca"
                                                className="estatoSelect"
                                                value={this.state.data.produtos}
                                                mode="multiple"
                                                onChange={(e) => this.handleChangeMarcaLocalizacao(e)}
                                                style={{ width: "100%" }}
                                            >
                                                <Option disabled >Selecione os produtos associados à marca</Option>
                                                {(this.state.marcaLocalizacao && !!this.state.marcaLocalizacao.length) && this.state.marcaLocalizacao.map((item, index) => (
                                                <Option key={index} value={item.idproduto}>{item.desproduto}</Option>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                    {/* condition for history and pending */}
                                    {this.state.parsed.estado === "Reprovado" ||
                                    this.state.parsed.estado === "Aprovado" ? (
                                        <>
                                            <div className="row ml-4">
                                                <div className="col-md-4">
                                                    <label className="rotulos_head mb-0">
                                                        Estado
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state.parsed &&
                                                            this.state.parsed
                                                                .estado}
                                                    </label>
                                                </div>
                                                <div className="col-md-4">
                                                    <label
                                                        htmlFor=""
                                                        className="rotulos_head mb-0"
                                                    >
                                                        Data de Validação
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state.data &&
                                                        this.state.data
                                                            .dataValidado
                                                            ? moment(
                                                                  this.state
                                                                      .data
                                                                      .dataValidado
                                                              ).format(
                                                                dateFormat
                                                              )
                                                            : "nd"}
                                                    </label>
                                                </div>
                                                <div className="col-md-4">
                                                    <label
                                                        htmlFor=""
                                                        className="rotulos_head mb-0"
                                                    >
                                                        Validado por
                                                    </label>
                                                    <br />
                                                    <label className="rotulos_content">
                                                        {this.state.data &&
                                                        this.state.data
                                                            .validadoPor
                                                            ? this.state.data
                                                                  .validadoPor
                                                            : "nd"}
                                                    </label>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-md-12 ml-4">
                                                <label className="rotulos_head mb-0">
                                                    Estado
                                                </label>
                                                <br />
                                                <div className="d-flex flex-row">
                                                {this.state.data.estado !="Pendente" && ( <div className=" mr-2">
                                                        <label htmlFor="Pedente" className="rotulos_content">
                                                            Pendente
                                                        </label>
                                                        <input
                                                            className="ml-1"
                                                            type="radio"
                                                            name="estado"
                                                            id="Pedente"
                                                            value="Pendente"
                                                            checked={
                                                                this.state.estado ===
                                                                "Pendente"
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    "radio",
                                                                    e
                                                                )
                                                            }
                                                        />
                                                    </div>)}
                                                    <div className="ml-2 mr-2">
                                                        <label htmlFor="Aprovado" className="rotulos_content">
                                                            Aprovado
                                                        </label>
                                                        <input
                                                            className="ml-1"
                                                            type="radio"
                                                            name="estado"
                                                            id="Aprovado"
                                                            value="Aprovado"
                                                            checked={
                                                                this.state.estado ===
                                                                "Aprovado"
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    "radio",
                                                                    e
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                    
                                                    <div className="ml-2 mr-2 ">
                                                        <label htmlFor="Reprovado" className="rotulos_content">
                                                            Reprovado
                                                        </label>
                                                        <input
                                                            className="ml-1"
                                                            type="radio"
                                                            name="estado"
                                                            id="Reprovado"
                                                            value="Reprovado"
                                                            checked={
                                                                this.state.estado ===
                                                                "Reprovado"
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    "radio",
                                                                    e
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                    {this.state.data.estado !="Pendente" && ( <div className="ml-2 mr-2">
                                                        <label htmlFor="Suspenso" className="rotulos_content">
                                                            Suspenso
                                                        </label>
                                                        <input
                                                            className="ml-1"
                                                            type="radio"
                                                            name="estado"
                                                            id="Suspenso"
                                                            value="Suspenso"
                                                            checked={
                                                                this.state.estado ===
                                                                "Suspenso"
                                                            }
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    "radio",
                                                                    e
                                                                )
                                                            }
                                                        />
                                                    </div>)}
                                                </div>
                                                
                                            </div>
                                            { $("#Suspenso").is(':checked')  &&(
                                            <div className="col-md-6 ml-4 mt-1" >
                                                    <div className="input-box active-grey form-group">
                                                        <label className="input-label">
                                                        Fundamento da decisão*
                                                        </label>
                                                        <textarea 
                                                            id="observation"
                                                            className="form-control heigh-auto input-1"
                                                            type="textarea"
                                                            value={
                                                                this.state
                                                                    .observation
                                                            }
                                                            name="observation"
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    "textarea",
                                                                    e
                                                                )
                                                            }
                                                        ></textarea>
                                                        {this.state
                                                            .requiredField
                                                            .observation && (
                                                            <span className="text-danger">
                                                                {" "}
                                                                Campo
                                                                obrigatório
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                )}
                                            {this.state.data.estado ===
                                                "Pendente" && $('#Reprovado').is(':checked') &&(
                                            <div className="col-md-6 ml-4 mt-1" >
                                                    <div className="input-box active-grey form-group">
                                                        <label className="input-label">
                                                        Fundamento da decisão*
                                                        </label>
                                                        <textarea 
                                                            id="observation"
                                                            className="form-control heigh-auto input-1"
                                                            type="textarea"
                                                            value={
                                                                this.state
                                                                    .observation
                                                            }
                                                            name="observation"
                                                            onChange={(e) =>
                                                                this.handleChange(
                                                                    "textarea",
                                                                    e
                                                                )
                                                            }
                                                        ></textarea>
                                                        {this.state
                                                            .requiredField
                                                            .observation && (
                                                            <span className="text-danger">
                                                                {" "}
                                                                Campo
                                                                obrigatório
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                )}
                                            {this.state.data.estado ===
                                                "Reprovado" && (
                                                    
                                                    <div className="col-md-12 ml-2">
                                                        
                                                    <div className="col-md-4">
                                                        <label className="rotulos_head mb-0">
                                                        Fundamento da decisão
                                                        </label>
                                                        
                                                        <br />
                                                        <label className="rotulos_content">
                                                            {this.state.data &&
                                                            this.state.data.observacoesReprovado
                                                            
                                                                ? this.state.data.observacoesReprovado
                                                                : "nd"}
                                                        </label>
                                                        </div>
                                                    </div>
                                            )}
                                        </>
                                    )}
                                </div>
                                {/* {this.state.parsed &&
                                    this.state.parsed.from ===
                                        "marcasApproved" && (
                                        <div
                                            className="bg-white middle p20 mb-4"
                                            id="Histórico"
                                        >
                                            <div className="head mb-4">
                                                <h2>Histórico</h2>
                                                <p className="font-14"></p>
                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <div className="row w-75 ">
                                                    <div>
                                                        {
                                                            this.state
                                                                .historyTable
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    )} */}
                            </div>
                        </div>
                        {/* cancelar Popup */}
                        <MarcasModal
                            modalId="marca-suspend"
                            title="Cancelar Marca"
                            warning={true}
                            textArea={true}
                            popUpId="confirm-marca-suspend"
                            handleConfirm={this.handleConfirm}
                            type="cancel"
                            
                        />
                        {/* confirm cancel popup */}
                        <MarcasModal
                            title="Cancelar Marca?"
                            modalId="confirm-marca-suspend"
                            desc="Deseja continuar com a operação? Ao alterar o estado do registo, este não poderá ser revertido."
                            centerButton={true}
                            handleConfirm={this.handleConfirm}
                            type="confirmCancel"
                        />
                        {/* suspend popup */}
                        <MarcasModal
                            modalId="marca-activate"
                            title="Suspender Marca"
                            textArea={true}
                            popUpId="confirm-marca-activate"
                            handleConfirm={this.handleConfirm}
                            type="suspend"
                        />
                        {/* confirm suspend popup */}
                        <MarcasModal
                            title="Suspender Marca?"
                            desc="Deseja continuar com a operação? O seu estado poderá ser revisto novamente na ficha do processo"
                            modalId="confirm-marca-activate"
                            centerButton={true}
                            handleConfirm={this.handleConfirm}
                            type="confirmSuspend"
                        />
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(MarcasNProcesso);
